import toast from "react-hot-toast";
import { useCreateSchoolSession } from "../../../../hooks/school/session/useCreateSchoolSession";
import { SessionFormRow } from "./SessionFormRow";

export const SchoolSessionForm = ({ users }) => {
  const { createSchoolSession } = useCreateSchoolSession();
  return (
    <>
      <div className="col-md-12">
        <p className="settingTitl">School Session</p>
        <SessionFormRow
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            try {
              await createSchoolSession({
                sessionData: values,
                onSuccess: () => {
                  toast.success("Session created");
                  resetForm(); // optional
                },
                onError: (msg) => toast.error(msg),
              });
            } finally {
              // 🔥 THIS LINE FIXES YOUR ISSUE
              setSubmitting(false);
            }
          }}
        />
      </div>
    </>
  );
};
